var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 0C12.1867 0 11.7265 0.187816 11.3871 0.522108L0.529992 11.2178C0.190652 11.5521 0 12.0055 0 12.4783V33.8696C0 36.8232 2.43046 39.2174 5.42857 39.2174H9.04762C10.047 39.2174 10.8571 38.4193 10.8571 37.4348C10.8571 36.4502 10.047 35.6522 9.04762 35.6522H5.42857C4.42921 35.6522 3.61905 34.8541 3.61905 33.8696V14.2609H12.6667C13.6661 14.2609 14.4762 13.4628 14.4762 12.4783V3.56522H27.1429C28.1423 3.56522 28.9524 4.36333 28.9524 5.34783V10.6957C28.9524 11.6802 29.7625 12.4783 30.7619 12.4783C31.7613 12.4783 32.5714 11.6802 32.5714 10.6957V5.34783C32.5714 2.39431 30.1411 0 27.1429 0H12.6667ZM10.8571 10.6957H6.17809L10.8571 6.0862V10.6957ZM16.2857 28.5217C16.2857 23.5992 20.3365 19.6087 25.3333 19.6087C30.3302 19.6087 34.381 23.5992 34.381 28.5217C34.381 33.4442 30.3302 37.4348 25.3333 37.4348C20.3365 37.4348 16.2857 33.4442 16.2857 28.5217ZM25.3333 16.0435C18.3377 16.0435 12.6667 21.6302 12.6667 28.5217C12.6667 35.4133 18.3377 41 25.3333 41C32.329 41 38 35.4133 38 28.5217C38 21.6302 32.329 16.0435 25.3333 16.0435ZM24.5276 23.4732C23.9722 23.1087 23.2584 23.0746 22.6699 23.3848C22.0816 23.695 21.7143 24.2991 21.7143 24.9565V32.087C21.7143 32.7444 22.0816 33.3485 22.6699 33.6587C23.2584 33.9689 23.9722 33.9348 24.5276 33.5703L29.9561 30.005C30.4595 29.6744 30.7619 29.1178 30.7619 28.5217C30.7619 27.9256 30.4595 27.3691 29.9561 27.0384L24.5276 23.4732Z",
    fill: "#ED1849"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f219fcd4e93326e18562fbaf07e99062.svg";
export { ForwardRef as ReactComponent };